export const darkGradientBlock = `data:image/svg+xml;base64,${btoa(`
    <svg width="256" height="256" xmlns="http://www.w3.org/2000/svg">
      <rect width="256" height="256" fill="#0a0a10"/>
      <rect width="256" height="256" fill="url(#grad)"/>
      <defs>
        <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%" gradientTransform="translate(0,0)">
          <stop offset="0%" stop-color="#0a0a10"/>
          <stop offset="50%" stop-color="#0D0D13"/>
          <stop offset="100%" stop-color="#0a0a10"/>
        </linearGradient>
      </defs>
    </svg>
  `)}`;
